import React from 'react'

/**
 * Context to hold a reference to the footer div where to display the footer
 * @type {React.Context<null>}
 */
const FooterContainerRefContext = React.createContext(null);

export default FooterContainerRefContext;
